/**
 * Component dimension constants
 * Centralizes magic numbers for sizes, widths, heights, etc.
 */
export const DIMENSIONS = {
  // Icon sizes
  ICON_SIZE_EXTRA_SMALL: 16,
  ICON_SIZE_SMALL: 20,
  ICON_SIZE_MEDIUM: 24,
  ICON_SIZE_LARGE: 28,
  ICON_SIZE_EXTRA_LARGE: 32,

  // Component specific dimensions
  CROP_DIALOG_HEIGHT: 400,
  REWRITE_CHAT_UI_WIDTH: 480,
  LANGUAGE_SWITCHER_HEIGHT: 36,
  PROGRESS_CIRCLE_SIZE: 20,
  DELETE_BUTTON_SIZE: 24,
  PROGRESS_DEFAULT_SIZE: 40,

  // Focus management
  FOCUS_SETUP_DELAY: 50,
} as const;
